import React, { FunctionComponent, ReactElement, useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import useConfig from '@empiriecom/module-components/hooks/useConfig';
import { FragmentConfiguration } from '@/config';
import { Card } from '@/src/components/Card';
import DynamicInstallmentCalculator from './Dynamic';
import DefaultInstallmentCalculator from './Fix';
import { useInstallmentCalculatorContext } from '../InstallmentCalculatorContext';

const messages = defineMessages({
  cardHeadline: {
    defaultMessage: 'Ratenrechner',
    id: 'installment-calculator.card-headline',
  },
  collapseLabel: {
    defaultMessage: 'Ratenrechner minimieren',
    id: 'installment-calculator.collapse-label',
  },
  expandLabel: {
    defaultMessage: 'Ratenrechner anzeigen',
    id: 'installment-calculator.expand-label',
  },
  sliderLabel: {
    defaultMessage: '{value} Monate',
    id: 'installment-calculator.range-min-max-label-text',
  },
});

/**
 *
 */
export const InstallmentCalculatorVariant: FunctionComponent = (): ReactElement => {
  const {
    installmentCalculator: { cardIdentifier, cardLayout },
  } = useConfig<FragmentConfiguration>();

  const { error, isLoading, response } = useInstallmentCalculatorContext();

  const [collapseThreshold, setCollapseThreshold] = useState<number>(0);
  const intl = useIntl();

  let calculatorVariant: JSX.Element;
  switch (response?.type) {
    case 'DYNAMIC':
      calculatorVariant = (
        <DynamicInstallmentCalculator setCollapseThreshold={setCollapseThreshold} />
      );
      break;
    case 'FIX':
    default:
      calculatorVariant = (
        <DefaultInstallmentCalculator setCollapseThreshold={setCollapseThreshold} />
      );
  }

  return (
    <>
      {/* render nothing if an error occured. */}
      {(error || (response && response.error)) && (
        <span data-testid="installment-calculator-error" data-error={response && response.error} />
      )}
      {isLoading && <></>}
      {!error &&
        response &&
        !response.error &&
        (cardLayout ? (
          <Card
            collapsible
            collapsibleId={cardIdentifier}
            controllable
            headline={intl.formatMessage(messages.cardHeadline)}
            contentPadding
            showCollapseOverlay={false}
            collapseThreshold={collapseThreshold}
            collapseLabelText={intl.formatMessage(messages.collapseLabel)}
            expandLabelText={intl.formatMessage(messages.expandLabel)}
          >
            {calculatorVariant}
          </Card>
        ) : (
          calculatorVariant
        ))}
    </>
  );
};

export default InstallmentCalculatorVariant;
